import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const TagIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { d: "M15 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", d: "M11.307 4.03A1 1 0 0 1 12 3.75h7.25a1 1 0 0 1 1 1V12a1 1 0 0 1-.294.709l-6.697 6.67a3 3 0 0 1-4.304-.072L4.56 14.625a3 3 0 0 1 .108-4.215l6.638-6.38Zm1.096 1.72-6.348 6.101a1 1 0 0 0-.036 1.406l4.394 4.681a1 1 0 0 0 1.435.024l6.402-6.377V5.75h-5.847Z", clipRule: "evenodd" }));
});
TagIcon.displayName = "TagIcon";
